import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { actualizarCon, enviaCodigo } from "../../Servicios/Servicios";

// /d:/Documents/git/git/event_front/src/pages/Restablecer/Restablecer.jsx

/**
 * Password reset page with two modes:
 * - Request reset link (enter email)
 * - Submit new password (when ?token=... is present in URL)
 *
 * Replace fetch URLs with your backend endpoints.
 */
import background from "../../assets/image/loginBackgroundContenedor.png";

export default function Restablecer() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const [valid, setValid] = useState(false);

  const [email, setEmail] = useState("");
  const [codigo, setCodigo] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setError(null);
    setMessage(null);
  }, [valid]);

  async function requestReset(e) {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Introduce un email válido.");
      return;
    }

    setLoading(true);
    try {
      // Adjust endpoint to your backend.
      
      const body = {correoUsuario: email}
      const res = await enviaCodigo(body);
      if (!res) throw new Error("No se pudo enviar el enlace de restablecimiento.");
      console.log(res)
      if (res.success) {
        
        setMessage("Si el correo existe, se ha enviado un enlace de restablecimiento.");
        setValid(true)
      }else{
        setMessage("Error al enviar el correo. "+ res.message);
      }

    } catch (err) {
      setError(err.message || "Error de red.");
    } finally {
      setLoading(false);
    }
  }

  async function submitNewPassword(e) {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (password.length < 8) {
      setError("La contraseña debe tener al menos 8 caracteres.");
      return;
    }
    if (password !== confirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setLoading(true);
    try {
      // Adjust endpoint to your backend.
      const bodyOpen = { correoUsuario: email, codigoTemporal: codigo, nuevaContrasena: password };
      const res = await actualizarCon(bodyOpen);
      if (res.success) {

        setMessage(res.message || "Contraseña restablecida correctamente. Redirigiendo al inicio de sesión...");
        setPassword("");
        setConfirm("");
        setTimeout(() => navigate("/login"), 2000);

      }else{
        setError("Error al restablecer la contraseña. "+ res.message);
      }
    } catch (err) {
      setError(err.response.data.message || "Error de red.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.container}>
      <div style={{...styles.card, backgroundImage: `url(${background})`,backgroundRepeat: 'no-repeat'}}>
        <h2 style={styles.title} className="text-white" >Restablecer contraseña</h2>

        {valid ? (
          <form onSubmit={submitNewPassword} style={styles.form}>
            <label style={styles.label}>
              <span className="text-white"><strong>Correo electrónico</strong></span>
              
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={styles.input}
                placeholder="tucorreo@ejemplo.com"
                disabled
              />
            </label>
            <label style={styles.label}>
              <span className="text-white"><strong>Código temporal</strong></span>
              <input
                type="number"
                value={codigo}
                onChange={(e) => {
                  const value = e.target.value.slice(0, 6);
                  setCodigo(value);
                }}
                style={styles.input}
                placeholder="Ingresa el código temporal"
              />
            </label>

            <label style={styles.label}>
              <span className="text-white"><strong>Nueva contraseña</strong></span>
              
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={styles.input}
                placeholder="Al menos 8 caracteres"
                minLength={8}
                required
              />
            </label>

            <label style={styles.label}>
              <span className="text-white"><strong>Confirmar contraseña</strong></span>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                style={styles.input}
                placeholder="Repite la contraseña"
                required
              />
            </label>

            <button style={styles.button} disabled={loading} className="bg-[#4F60A8] text-white rounded hover:bg-[#4F60A8]-100">
              {loading ? "Procesando..." : "Restablecer contraseña"}
            </button>
          </form>
        ) : (
          <form onSubmit={requestReset} style={styles.form}>
            <label style={styles.label}>
              <span className="text-white"><strong>Correo electrónico</strong></span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={styles.input}
                placeholder="tucorreo@ejemplo.com"
                required
              />
            </label>

            <button style={styles.button} disabled={loading} className="bg-[#4F60A8] text-white rounded hover:bg-[#4F60A8]-100">
              {loading ? "Enviando..." : "Enviar enlace de restablecimiento"}
            </button>
          </form>
        )}

        {message && <div style={styles.message}>{message}</div>}
        {error && <div style={styles.error}>{error}</div>}

        <div style={styles.footer}>
          <button onClick={() => navigate(-1)} style={styles.linkButton}>
            Volver
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
  },
  card: {
    width: "100%",
    maxWidth: 420,
    borderRadius: 8,
    padding: 24,
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
  },
  title: { margin: "0 0 12px", textAlign: "center" },
  form: { display: "flex", flexDirection: "column", gap: 12 },
  label: { fontSize: 14, display: "flex", flexDirection: "column", gap: 6,},
  input: {
    padding: "10px 12px",
    borderRadius: 6,
    border: "1px solid #ccc",
    fontSize: 14,
  },
  button: {
    padding: "10px 12px",
    borderRadius: 6,
    border: "none",
    color: "#fff",
    fontSize: 15,
    cursor: "pointer",
  },
  message: {
    marginTop: 12,
    padding: 10,
    borderRadius: 6,
    background: "#e6ffed",
    color: "#064e3b",
  },
  error: {
    marginTop: 12,
    padding: 10,
    borderRadius: 6,
    background: "#ffecec",
    color: "#7f1d1d",
  },
  footer: { marginTop: 12, textAlign: "center" },
  linkButton: {
    background: "transparent",
    border: "none",
    color: "#0366d6",
    cursor: "pointer",
    padding: 6,
    fontSize: 14,
  },
};